export default {
    state: {
        // The main object that will store all your key-value pairs
        storedObject: {}
    },
    
    getters: {
        // Get the entire stored object
        getStoredObject: (state) => state.storedObject,
        
        // Get a specific value from the stored object by key
        getStoredValue: (state) => (key) => state.storedObject[key]
    },
    
    mutations: {
        // Set a specific key-value pair in the object
        SET_OBJECT_KEY(state, { key, value }) {
            state.storedObject[key] = value;
        },
        
        // Replace the entire stored object
        REPLACE_OBJECT(state, newObject) {
            state.storedObject = newObject;
        },
        
        // Clear a specific key from the object
        CLEAR_OBJECT_KEY(state, key) {
            if (key in state.storedObject) {
                delete state.storedObject[key];
            }
        },
        
        // Clear the entire object
        CLEAR_OBJECT(state) {
            state.storedObject = {};
        }
    },
    
    actions: {
        // Action to set a key-value pair
        setObjectKey({ commit }, { key, value }) {
            commit('SET_OBJECT_KEY', { key, value });
        },
        
        // Action to replace the entire object
        replaceObject({ commit }, newObject) {
            commit('REPLACE_OBJECT', newObject);
        },
        
        // Action to clear a specific key
        clearObjectKey({ commit }, key) {
            commit('CLEAR_OBJECT_KEY', key);
        },
        
        // Action to clear the entire object
        clearObject({ commit }) {
            commit('CLEAR_OBJECT');
        }
    }
};